import Link from 'next/link'
import styled from 'styled-components'

import Icon from '@ilg-totallymoney/ui/icons/Icon'
import anchorStyles from '@ilg-totallymoney/ui/styles/anchor'
import { focusStylesWithRoundedEdges } from '@ilg-totallymoney/ui/styles/focus'
import theme from '@ilg-totallymoney/ui/theme'

export const StyledNextLink = styled(Link)`
    display: inline-flex;
    align-items: center;

    ${anchorStyles};
    ${focusStylesWithRoundedEdges};
`

export const StyledIcon = styled(Icon)`
    margin-left: ${theme.space10};

    &:hover {
        color: ${theme.indigo80};
    }
`
